import { IconExclamationCircleFilled } from '@u21/tabler-icons';
import {
  ConsortiumAlertsSummary as ConsortiumAlertsSummaryData,
  ConsortiumAlertsSummaryDispositionType,
} from 'app/modules/consortium/responses';
import { ConsortiumAlertsSummary } from 'app/modules/consortium/components/ConsortiumAlertsSummary';
import {
  U21Button,
  U21ButtonColor,
  U21MenuLayout,
  U21Spacer,
} from 'app/shared/u21-ui/components';
import { useMemo, useState } from 'react';
import styled from 'styled-components';

const CONSORTIUM_DISPOSITION_TYPE_COLORS: Record<
  ConsortiumAlertsSummaryDispositionType,
  U21ButtonColor
> = {
  true_positive: 'error',
  under_review: 'warning',
  false_positive: 'success',
  open: 'info',
};

export const ConsortiumSummaryPopover = ({
  consortiumAlertsSummary,
}: {
  consortiumAlertsSummary: ConsortiumAlertsSummaryData;
}) => {
  const [open, setOpen] = useState(false);
  const highestSeverityDispositionType =
    useMemo<ConsortiumAlertsSummaryDispositionType>(() => {
      if (consortiumAlertsSummary.all_time.true_positive.count > 0) {
        return 'true_positive';
      }
      if (consortiumAlertsSummary.all_time.under_review.count > 0) {
        return 'under_review';
      }
      if (consortiumAlertsSummary.all_time.open.count > 0) {
        return 'open';
      }
      return 'false_positive';
    }, [consortiumAlertsSummary]);

  return (
    <U21MenuLayout
      trigger={
        <U21Button
          icon={<IconExclamationCircleFilled />}
          color={
            CONSORTIUM_DISPOSITION_TYPE_COLORS[highestSeverityDispositionType]
          }
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
          tooltip="Consortium Summary"
          aria-label="Consortium Summary"
        />
      }
      onClose={() => setOpen(false)}
      open={open}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <StyledWrapper>
        <ConsortiumAlertsSummary
          consortiumAlertsSummary={consortiumAlertsSummary}
        />
      </StyledWrapper>
    </U21MenuLayout>
  );
};

const StyledWrapper = styled(U21Spacer)`
  padding: 16px;
  min-width: 350px;
  max-width: 500px;
`;
